<h2 mat-dialog-title>
  Add Child Account
  <span class="child-dialog-parent">Parent: {{ data.masterName }} (#{{ data.masterId }})</span>
</h2>

<mat-dialog-content [formGroup]="form" class="child-dialog-content">

  <mat-form-field appearance="outline" class="full-width br-mb-2">
    <mat-label>Display Name</mat-label>
    <input matInput formControlName="displayName" />
    <mat-error>Required</mat-error>
  </mat-form-field>

  <div class="br-form-label br-mb-2">Service Address</div>

  <div formGroupName="serviceAddress">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Address Line 1</mat-label>
      <input matInput formControlName="line1" />
      <mat-error>Required</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Address Line 2</mat-label>
      <input matInput formControlName="line2" />
    </mat-form-field>
    <div class="br-flex br-gap-2">
      <mat-form-field appearance="outline" class="br-flex-grow-1 br-min-w-0">
        <mat-label>City</mat-label>
        <input matInput formControlName="city" />
        <mat-error>Required</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" class="child-dialog-state">
        <mat-label>State</mat-label>
        <mat-select formControlName="stateId">
          <mat-option *ngFor="let state of states" [value]="state.id">{{ state.code }}</mat-option>
        </mat-select>
        <mat-error>Required</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" class="child-dialog-zip">
        <mat-label>ZIP</mat-label>
        <input matInput formControlName="zip" />
        <mat-error>Required</mat-error>
      </mat-form-field>
    </div>
  </div>

  <mat-checkbox formControlName="differentBilling" class="br-block br-mt-2 br-mb-3">
    Billing address is different from service address
  </mat-checkbox>

  <ng-container *ngIf="differentBilling" formGroupName="billingAddress">
    <div class="br-form-label br-mb-2">Billing Address</div>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Address Line 1</mat-label>
      <input matInput formControlName="line1" />
    </mat-form-field>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Address Line 2</mat-label>
      <input matInput formControlName="line2" />
    </mat-form-field>
    <div class="br-flex br-gap-2">
      <mat-form-field appearance="outline" class="br-flex-grow-1 br-min-w-0">
        <mat-label>City</mat-label>
        <input matInput formControlName="city" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="child-dialog-state">
        <mat-label>State</mat-label>
        <mat-select formControlName="stateId">
          <mat-option *ngFor="let state of states" [value]="state.id">{{ state.code }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="child-dialog-zip">
        <mat-label>ZIP</mat-label>
        <input matInput formControlName="zip" />
      </mat-form-field>
    </div>
  </ng-container>

  <mat-error *ngIf="error" class="br-block br-mt-2">{{ error }}</mat-error>

</mat-dialog-content>

<mat-dialog-actions align="end" class="br-gap-2">
  <button type="button" class="br-btn br-btn--outline-secondary" (click)="cancel()" [disabled]="saving">Cancel</button>
  <button type="button" class="br-btn br-btn--primary" (click)="save()" [disabled]="saving">
    <br-icon *ngIf="saving">hourglass_empty</br-icon>
    {{ saving ? 'Adding...' : 'Add Child' }}
  </button>
</mat-dialog-actions>
